module.exports = __webpack_public_path__ + "img/4.0e977d20.png";